// extracted by mini-css-extract-plugin
export default {"qmpBanner":"Banner_qmpBanner__LRHZl"};